// The left-to-right mark ('\u200E') indicates that the browser should not attempt any right-to-left conversion which can cause formatting errors.
// See more: https://en.wikipedia.org/wiki/Left-to-right_mark
export var sliderLocale = {
  selectedRange: function selectedRange(_ref) {
    var start = _ref.start,
        end = _ref.end;
    return "\u200E".concat(start, " to ").concat(end);
  },
  startAriaLabel: 'Start',
  endAriaLabel: 'End'
};